<template>
    <div>
        <MenuAccount/>
        <DailyCostReportList/>
    </div>
</template>

<script>

import MenuAccount from '@/components/menuadmin/account/accountheader/MenuAccount.vue'
import DailyCostReportList from '@/components/menuadmin/account/accountreport/DailyCostReportList.vue'
export default {
    name:'dailyCostReport',
    components:{
        MenuAccount,
        DailyCostReportList,
    },
}
</script>